import { render, staticRenderFns } from "./CustomerBillDetailList.vue?vue&type=template&id=4106d7ea"
import script from "./CustomerBillDetailList.vue?vue&type=script&lang=js"
export * from "./CustomerBillDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports